import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="oms--oms--quote-confirmation"
export default class extends Controller {
  connect() {
    // Add event listeners for confirmation buttons
    this.addConfirmationListeners()
  }

  addConfirmationListeners() {
    // Listen for clicks on confirmation buttons
    document.addEventListener('click', this.handleConfirmationClick.bind(this))
  }

  handleConfirmationClick(event) {
    const target = event.target.closest('[data-action*="oms--oms--quote-confirmation#showModal"]')
    if (!target) return

    event.preventDefault()
    event.stopPropagation()

    const actionName = target.dataset.actionName
    const quoteId = target.dataset.quoteId
    const modalId = `confirmation-modal-${actionName}-${quoteId}`

    this.showModal(modalId)
  }

  showModal(event) {
    // Handle both direct calls and event-based calls
    let modalId
    if (event && event.currentTarget) {
      const actionName = event.currentTarget.dataset.actionName
      const quoteId = event.currentTarget.dataset.quoteId

      // Special handling for Accept Quote - use the accept confirmation modal
      if (actionName === 'accept-quote') {
        this.showAcceptModal(quoteId)
        return
      }

      modalId = `confirmation-modal-${actionName}-${quoteId}`
    } else {
      modalId = event // Direct call with modalId
    }

    // Close any open dropdown menus
    this.closeAllDropdownMenus()

    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.remove('hidden')
      // Focus on the confirm button for accessibility
      const confirmButton = modal.querySelector('[type="submit"]')
      if (confirmButton) {
        confirmButton.focus()
      }
    }
  }

  showAcceptModal(quoteId) {
    // Close any open dropdown menus
    this.closeAllDropdownMenus()

    const modal = document.getElementById(`accept-modal-${quoteId}`)
    if (modal) {
      modal.classList.remove('hidden')
      const checkbox = document.querySelector(`input[data-quote-id="${quoteId}"]`)

      if (checkbox) {
        checkbox.checked = false
        // Trigger the accept confirmation controller's checkbox handling
        const acceptController = this.application.getControllerForElementAndIdentifier(
          document.querySelector('[data-controller*="oms--oms--accept-confirmation"]'), 
          "oms--oms--accept-confirmation"
        )
        if (acceptController) {
          checkbox.addEventListener('change', acceptController.handleCheckboxChange.bind(acceptController))
        }
      }
    }
  }

  closeAllDropdownMenus() {
    // Close any open row action menus
    document.querySelectorAll('[data-controller*="oms--oms--row-actions-menu"]').forEach(menu => {
      const controller = this.application.getControllerForElementAndIdentifier(menu, "oms--oms--row-actions-menu")
      if (controller && controller.openValue) {
        controller.closeMenu()
      }
    })
  }

  closeModal() {
    // Close all confirmation modals
    const modals = document.querySelectorAll('[id^="confirmation-modal-"]')
    modals.forEach(modal => {
      modal.classList.add('hidden')
    })
  }

  confirmAction(event) {
    event.preventDefault()

    const quoteId = event.currentTarget.dataset.quoteId
    const actionName = event.currentTarget.dataset.actionName

    const confirmButton = document.querySelector(`#confirm-button-${quoteId}-${actionName}`)
    const spinnerButton = document.querySelector(`#confirm-button-spinner-${quoteId}-${actionName}`)

    if (confirmButton && spinnerButton) {
      confirmButton.classList.add('!hidden')
      spinnerButton.classList.remove('!hidden')
    }

    const form = document.getElementById(`confirmation-form-${quoteId}-${actionName}`)
    if (form) {
      form.submit()
    }
  }
}
